module.exports = __webpack_public_path__ + "static/media/HCC1.cd0fad9d.jpg";